import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.75 0a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 8.75 0m4.03 2.28a.75.75 0 0 0-1.06-1.06l-1 1a.75.75 0 0 0 1.06 1.06zM9.707 5.707a1 1 0 0 0-1.414-1.414l-8 8a1 1 0 1 0 1.414 1.414zM11.75 4.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm-1.53 2.22a.75.75 0 0 1 1.06 0l1 1a.75.75 0 0 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06m-3.94-5a.75.75 0 0 0-1.06 1.06l1 1a.75.75 0 0 0 1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Magic = { render };
export {
  Magic as default,
  render
};
//# sourceMappingURL=Magic.svg.js.map
